const AnswerDisplay = ({ answer, chunks, selectedChunk, setSelectedChunk }) => {
  const handleChunkClick = (index) => {
    setSelectedChunk(index);
  };

  const isChunkSelected =
    selectedChunk !== null &&
    selectedChunk !== undefined &&
    chunks[selectedChunk];

  return (
    <div className="mt-1">

      {answer && (
        <div>
          {/* FULL ANSWER ALWAYS SHOWN ON TOP */}
          <h2 className="text-xl font-medium text-gray-900 mb-0">
            Answer
          </h2>
          <div className="border border-gray-300 rounded-md p-4 bg-white shadow-sm mb-1">
            <p className="text-gray-700 whitespace-pre-line text-justify">
              {answer}
            </p>
          </div>
        </div>
      )}

      {/* CHUNK BUTTONS */}
      {chunks.length > 0 && (
        <>
          <h2 className="text-xl font-medium text-gray-900 mb-0">
            Relevant Retrieve Chunks
          </h2>
          <div className="flex flex-wrap gap-2 mb-0">
            {chunks.map((chunk, index) => (
              <button
                key={index}
                onClick={() => handleChunkClick(index)}
                className={`px-4 py-2 rounded-md ${selectedChunk === index
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  } transition-colors`}
              >
                {`Chunk ${index + 1}`}
              </button>
            ))}
          </div>
        </>
      )}

      {/* SELECTED CHUNK CONTENT BELOW BUTTONS */}
      {isChunkSelected && (
        <div className="border border-gray-300 rounded-md p-4 bg-white shadow-sm">
          {/* <h2 className="text-lg font-medium text-gray-700 mb-2">
            {`Chunk ${selectedChunk + 1}`}
          </h2> */}

          <p className="text-gray-700 whitespace-pre-line text-justify">
            {chunks[selectedChunk].content || "(Empty chunk)"}
          </p>
        </div>
      )}
    </div>
  );
};

export default AnswerDisplay;
